import { render, staticRenderFns } from "./technialProblem.vue?vue&type=template&id=201b2ada&scoped=true&"
import script from "./technialProblem.vue?vue&type=script&lang=ts&"
export * from "./technialProblem.vue?vue&type=script&lang=ts&"
import style0 from "./technialProblem.vue?vue&type=style&index=0&id=201b2ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b2ada",
  null
  
)

export default component.exports